<template>
    <div>
        <el-card>
            <div class="tableBox">
                <div>
                    <div>
                        <span>服务台</span>
                        <span>人员事件统计</span>
                    </div>
                    <img src="../../../../assets/icon_logo.png">
                </div>
                <div>
                    <div>
                        <el-form :inline="true" class="search-form">
                            <el-form-item label="">
                                <el-date-picker
                                    ref="dataPicker"
                                    @change="changeData"
                                    v-model="value"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-button type="primary" @click="selectData">修改时间</el-button>
                        </el-form>
                    </div>
                    <div class="tableClass">
                        <div>
                            <el-table
                                :data="tableData"
                                show-summary>
                                <el-table-column width="80" prop="name" label="人员名称"></el-table-column>
                                <el-table-column prop="num1" label="受理事件请求的数量" sortable :sort-orders="sortList"></el-table-column>
                                <el-table-column prop="num2" label="服务台直接处理完成数" sortable :sort-orders="sortList"></el-table-column>
                            </el-table>
                        </div>
                        <div ref="myChart"></div>
                    </div>
                </div>
                <div>
                    <div>
                        <span>生成时间:</span>
                        <span>2019-09-06 10:43:37</span>
                    </div>
                    <span>itsmops.autoai.com</span>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>

    export default {
        data: function () {
            return {
                tableData: [
                    {name: '王雪昕',num1: '10',num2:'90'},
                    {name: '刘敏',num1: '60',num2:'100'}
                ],
                sortList:['descending', 'ascending'],
                value:'',
                options:{
                    tooltip : {},
                    legend: {},
                    dataset:{
                        source:[
                            ['product','受理事件请求的数量','服务台直接处理完成数'],
                            ['王雪昕','10','90'],
                            ['刘敏','60','100'],
                        ]
                    },
                    dataZoom:[
                        {
                            type: 'inside',
                            xAxisIndex: 0,
                        },
                        {
                            type: 'slider',
                            xAxisIndex: 0,
                        },
                        {
                            type: 'inside',
                            yAxisIndex: 0,
                        },
                        {
                            type: 'slider',
                            yAxisIndex: 0,
                        },
                    ],
                    xAxis: [{type: 'category',}],
                    yAxis: [{}],
                    series: [
                        {
                            type:'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                        {
                            type:'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                        },
                    ]
                },
            }
        },
        mounted(){
            this.getEcharts();
        },
        methods:{
            selectData(){//点击修改日期 日期控件自动聚焦
                let selData = this.$refs.dataPicker;
                selData.focus();
            },
            changeData(){//选择日期
                alert(12)
            },
            getEcharts(item){//实例化图标
                let myChart = this.$echarts.init(this.$refs.myChart);
                myChart.setOption(this.options);
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .tableClass{
        display: flex;
        &>div:nth-child(1){
            width: 40%;
        }
        &>div:nth-child(2){
            width: 60%;
            height:400px;
        }
    }
</style>
